import Marquee from "react-fast-marquee";

const ITEMS = [
  "COLD-PRESSED DAILY",
  "NO ADDED SUGAR",
  "REAL FRUIT & VEG",
  "SMALL BATCH",
  "BOTTLED FRESH",
  "NUTRIENT DENSE",
  "NO CONCENTRATES",
];

const EditorialMarquee = () => (
  <div className="relative py-5 bg-[#1A1A1A] overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={`${item}-${i}`} className="flex items-center">
          <span className="font-display font-extrabold text-2xl sm:text-3xl text-[#FFF8F0] px-6 tracking-tight">
            {item}
          </span>
          <span className="text-[#FFC93C] text-2xl">✳</span>
        </div>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
